define('widgets/valuablesList/viewmodel',['knockout', 'durandal/composition'], function (ko, composition) {

    var ValuablesList = function(itemManager, getField) {
        this.itemManager = itemManager;
        this.expiresText = function(item) {
            return getField('expires_text', {
                expiration: item.expirationTime.fromNow()
            });
        };
        this.activeLabel = getField('active_item_label');
        this.notSupportedLabel = getField('not_supported_label');
    };

    ValuablesList.prototype.useItem = function(item) {
        this.itemManager.useItem(item).then(this.onUse);
    };

    ValuablesList.prototype.activate = function(settings) {
        this.onUse = settings.onUse || function() {};
        this.valuables = settings.valuables || ko.observableArray([]);
    };

    return ValuablesList;
});

